import type { Job, JobAction } from 'src/app/v1/state/types/job';

const defaultState: Job = {
  id: undefined,
  idempotencyKey: undefined,
  revisionId: undefined,
};

const RESET = 'session/job/RESET';
const UPDATE = 'session/job/UPDATE';

export const actionResetJob = () => ({
  type: RESET,
});

export const actionUpdateJob = (value: Job) => ({
  type: UPDATE,
  value,
});

export default (state: Job = defaultState, action: JobAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
